import { css } from "@emotion/react";

export const containerFluid = css`
  padding: 20px 15px;
`;
